import { Gradient, NumberConfig, Price } from '../Helper/types';
import { ProductData } from '../Bundles/types';
import { EFontWeights } from '../Helper/enums';

export type DailyBonusProductProps = {
    quantityDisplay: string;
    textColor: string;
    images: Record<string, string>;
    quantityFormat?: NumberConfig;
};

export enum BannerAspectRatio {
    SQUARE = '1 / 1',
    TWO_ON_THREE = '2 / 3'
}

export interface DailyBonusModalProps {
    title: string;
    titleSize?: string;
    titleColor?: string; // Supports only solid
    borderColor?: Gradient;
    borderWidth?: number;
    titleWeight?: EFontWeights;
    backgroundColor?: string;
    backgroundImage?: string;
    buttonText?: string;
    products?: ProductData[];
    onCollect: () => any;
    onClose?: (p: { isShowingNextProduct: boolean }) => void;
    onAnimationSuccessEndNoPreview?: () => void;
    modalContainer?: Element | (() => Element | null) | null;
    isPreview?: boolean;
    nextProducts?: ProductData[];
    nextAvailableCollectUTC?: Date;
    showEvery?: number; // for testing purposes
    showCloseButton?: boolean;
}

export interface PostPurchaseProps {
    title: string;
    titleSize?: string;
    titleColor?: string; // Supports only solid
    borderColor?: Gradient;
    borderWidth?: number;
    titleWeight?: EFontWeights;
    backgroundColor?: string;
    backgroundImage?: string;
    buttonText?: string;
    products?: ProductData[];
    onActionBtnClicked: () => any;    
    onClose?: (p: { isShowingNextProduct: boolean }) => void;    
    isPreview?: boolean;
    modalContainer?: Element | (() => Element | null) | null;
    showCloseButton?: boolean;
    price?: Price;
}